import React from 'react';
import { Navbar, Nav, Image } from 'react-bootstrap';
import { NavDropdown } from 'react-bootstrap';
import logo from '../../resources/ACLangLogoMain.png';

const Header = ({ isLoggedIn, isAdmin, isOrg, userGroup, logout }) => {
  return (
    <Navbar sticky="top" bg="light" expand="lg" className="site-navbar">
      <Navbar.Brand href="/" className="ps-5">
        <Image src={logo} alt="Company Logo" width={164} height={64} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between align-items-lg-center">
        <Nav className="flex-grow-1 px-lg-3 justify-content-lg-center">
          <Nav.Link href="/">Home</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/about">About</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/bio">Bio</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/testimonials">Testimonials</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/students">Students</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/schools-and-teachers">Schools and Teachers</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/agents">Agents</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/faq">FAQ</Nav.Link>
          <Navbar.Text className="px-1 text-muted">|</Navbar.Text>
          <Nav.Link href="/free-consultation" className="highlight-link">Free Consultation</Nav.Link>
        </Nav>
        <Nav className="ms-lg-3 pe-3 flex-shrink-0 text-nowrap">
        { isLoggedIn ?
            (<NavDropdown title="Account" id="basic-nav-dropdown" align="end">
                { isOrg ? 
                    (<NavDropdown.Item href="courses">Courses</NavDropdown.Item>)
                    :
                    (<>{ isAdmin ? 
                        (<div>
                            <NavDropdown.Item href="admin">Admin</NavDropdown.Item>
                            <NavDropdown.Item href="courses">Courses</NavDropdown.Item>
                        </div>)
                        : 
                        (<div>
                            <NavDropdown.Item href="my-account">My Account</NavDropdown.Item>
                          { userGroup === "Student" && <NavDropdown.Item href="courses">My Online Courses</NavDropdown.Item> }
                            <NavDropdown.Item href="my-modules">My Modules</NavDropdown.Item>
                            <NavDropdown.Item href="my-bookings">My Consultation/Lesson Bookings</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="my-lessons">My Upcoming Lessons</NavDropdown.Item>
                        </div>)
                    }</>)
                }
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
            </NavDropdown>)
            : 
            (<>
            <Navbar.Text className="login-label">Login - </Navbar.Text>
            <Nav.Link href="/login">Personal</Nav.Link>
            <Navbar.Text>|</Navbar.Text>
            <Nav.Link href="/org-login">Organisation</Nav.Link>
            </>)
        }
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
